import { gql } from '@apollo/client';

export const GET_TENJIN_FILES = gql`
  query getFilesTenjin {
    getFilesTenjin {
      answerFiles {
        name
      }
      questionFiles {
        name
      }
    }
  }
`;

export const GET_TENJIN_UPLOAD_URL = gql`
  query getSignedUrlUploadTenjin($targetPath: String!) {
    getSignedUrlUploadTenjin(query: { targetPath: $targetPath })
  }
`;

export const GET_TENJIN_DOWNLOAD_URL = gql`
  query getSignedUrlDownloadTenjin($targetPath: String!) {
    getSignedUrlDownloadTenjin(query: { targetPath: $targetPath })
  }
`;

export const GENERATE_TENJIN_ANSWER = gql`
  mutation generateAnswerTenjin($question: String!, $settings: SettingsRequest, $taskId: String!) {
    generateAnswerTenjin(query: { question: $question, settings: $settings, taskId: $taskId })
  }
`;

export const ON_TENJIN_ANSWER = gql`
  subscription onTenjinAnswer($taskId: String!) {
    tenjinAnswer(taskId: $taskId) {
      taskId
      content
      error
      messageOrder
    }
  }
`;
